import { useParams } from "react-router";

import { useSelector } from "@jti/store/reduxHooks";

export const useMinimumPayableAmount = (): { isReached: boolean } => {
  const { orderId } = useParams<{ orderId: string }>();

  const { value: cartGrandTotalValue = 0 } = useSelector((state) => state.cart?.prices.data?.grandTotal) ?? {};
  const { value: minimumPayableAmountValue = 0 } = useSelector((state) => state.cart.minimumPayableAmount) ?? {};

  if (orderId) {
    return { isReached: false };
  }

  return { isReached: cartGrandTotalValue < minimumPayableAmountValue };
};
